module.exports = __webpack_public_path__ + "static/media/kts.c034fdbb.png";